import { TileCardDetails } from "../page/Interfaces";

interface Location {
  latitude: number;
  longitude: number;
}

export const calculateDistance = (
  lat1: number,
  lng1: number,
  lat2: number,
  lng2: number
) => {
  const earthRadius = 6371; // Earth's radius in kilometers

  const radLat1 = (Math.PI * lat1) / 180;
  const radLat2 = (Math.PI * lat2) / 180;
  const deltaLat = (Math.PI * (lat2 - lat1)) / 180;
  const deltaLng = (Math.PI * (lng2 - lng1)) / 180;

  const a =
    Math.sin(deltaLat / 2) * Math.sin(deltaLat / 2) +
    Math.cos(radLat1) *
      Math.cos(radLat2) *
      Math.sin(deltaLng / 2) *
      Math.sin(deltaLng / 2);

  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

  return earthRadius * c; // Distance in kilometers
};

/** Human-readable distance for listing cards (e.g. "850 m away", "2.1 km away"). */
export function formatDistanceFromKm(km: number): string {
  if (!Number.isFinite(km) || km < 0) {
    return "—";
  }
  if (km < 1) {
    return `${Math.round(km * 1000)} m away`;
  }
  const rounded = km < 10 ? Math.round(km * 10) / 10 : Math.round(km);
  const text = Number.isInteger(rounded) ? `${rounded}` : `${rounded}`;
  return `${text} km away`;
}

type UserLocationInput = Location | null | undefined;

/** Returns null when user location or turf coordinates are missing. */
export function getTurfDistanceLabel(
  userLocation: UserLocationInput,
  turf: Pick<TileCardDetails, "data">
): string | null {
  if (!userLocation) return null;
  const { latitude: uLat, longitude: uLng } = userLocation;
  if (!Number.isFinite(uLat) || !Number.isFinite(uLng)) return null;

  const loc = turf?.data?.location;
  const tLat = Number(loc?.latitude);
  const tLng = Number(loc?.longitude);
  if (!Number.isFinite(tLat) || !Number.isFinite(tLng)) return null;

  const km = calculateDistance(uLat, uLng, tLat, tLng);
  return formatDistanceFromKm(km);
}

export const sortTurfByLocation = (
  turfDetails: TileCardDetails[],
  userLocation: Location | null
) => {
  if (!userLocation) {
    return turfDetails;
  }

  return turfDetails.slice().sort((a, b) => {
    // Add null checks for data and location properties
    const locationA = a?.data?.location;
    const locationB = b?.data?.location;
    
    // If either location is missing, put them at the end
    if (!locationA || !locationB) {
      if (!locationA && !locationB) return 0;
      if (!locationA) return 1;
      if (!locationB) return -1;
    }
    
    // Ensure latitude and longitude exist and are valid numbers
    const latA = Number(locationA?.latitude);
    const lngA = Number(locationA?.longitude);
    const latB = Number(locationB?.latitude);
    const lngB = Number(locationB?.longitude);
    
    // Check if coordinates are valid numbers
    if (isNaN(latA) || isNaN(lngA) || isNaN(latB) || isNaN(lngB)) {
      if (isNaN(latA) || isNaN(lngA)) return 1;
      if (isNaN(latB) || isNaN(lngB)) return -1;
      return 0;
    }
    
    const distanceA = calculateDistance(
      userLocation.latitude,
      userLocation.longitude,
      latA,
      lngA
    );

    const distanceB = calculateDistance(
      userLocation.latitude,
      userLocation.longitude,
      latB,
      lngB
    );

    return distanceA - distanceB;
  });
};


// import { TileCardDetails } from "../pages/Interfaces";

// interface Location {
//   latitude: number;
//   longitude: number;
// }

// export const calculateDistance = (
//   coords1: [number, number],
//   coords2: [number, number]
// ) => {
//   const earthRadius = 6371; // Earth's radius in kilometers

//   const [lat1, lng1] = coords1;
//   const [lat2, lng2] = coords2;

//   const toRadians = (degree: number) => (Math.PI * degree) / 180;

//   const radLat1 = toRadians(lat1);
//   const radLat2 = toRadians(lat2);
//   const deltaLat = toRadians(lat2 - lat1);
//   const deltaLng = toRadians(lng2 - lng1);

//   const a =
//     Math.sin(deltaLat / 2) * Math.sin(deltaLat / 2) +
//     Math.cos(radLat1) *
//       Math.cos(radLat2) *
//       Math.sin(deltaLng / 2) *
//       Math.sin(deltaLng / 2);

//   const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

//   return earthRadius * c; // Distance in kilometers
// };

// export const sortTurfByLocation = (
//   turfDetails: TileCardDetails[],
//   userLocation: Location
// ) => {
//   return turfDetails.slice().sort((a, b) => {
//     const { latitude: lat1, longitude: lng1 } = a.data.location;
//     const { latitude: lat2, longitude: lng2 } = b.data.location;

//     const coords1: [number, number] = [userLocation.latitude, userLocation.longitude];
//     const coords2: [number, number] = [Number(lat1), Number(lng1)];

//     const distanceA = calculateDistance(coords1, coords2);
//     const distanceB = calculateDistance(coords1, coords2); 

//     return distanceA - distanceB;
//   });
// };